<div class="step-container">
  <h2 class="step-titulo">Importar cardápio</h2>
  <p class="step-subtitulo" *ngIf="!preview">Escolha a plataforma e cole o link da sua loja.</p>
  <p class="step-subtitulo" *ngIf="preview">Confira os dados encontrados antes de continuar.</p>

  <!-- Seleção de plataforma: Sistemas -->
  <div *ngIf="!importando && !preview">
    <label class="grupo-label">Seu sistema de cardápio</label>
    <div class="plataformas-grid">
      <div class="plataforma-card"
           *ngFor="let p of sistemas"
           [class.selecionada]="plataformaSelecionada === p.id"
           (click)="selecionarPlataforma(p.id)">
        <img [src]="p.logo" [alt]="p.nome" class="plataforma-logo" [class.plataforma-logo-goomer]="p.id === 'goomer'">
        <span>{{ p.nome }}</span>
      </div>
    </div>

    <div class="divisor-texto">
      <span>Nao usa nenhum dos sistemas acima?</span>
    </div>
    <div class="plataforma-card plataforma-card-ifood"
         *ngFor="let p of marketplaces"
         [class.selecionada]="plataformaSelecionada === p.id"
         (click)="selecionarPlataforma(p.id)">
      <img [src]="p.logo" [alt]="p.nome" class="plataforma-logo">
      <div class="plataforma-ifood-info">
        <span>Importar do {{ p.nome }}</span>
        <small>Importa produtos diretamente do link do iFood</small>
      </div>
    </div>
  </div>

  <!-- Campo URL -->
  <div class="url-form mt-3" *ngIf="plataformaSelecionada && !importando && !preview">
    <div class="form-group mb-3">
      <label class="campo-label">Link da sua loja</label>
      <input #linkInput type="text" class="campo-input"
             [(ngModel)]="url"
             [placeholder]="placeholderAtual"
             (keyup.enter)="importar()">
    </div>

    <p class="text-danger" *ngIf="erro">
      <i class="fe-alert-circle mr-1"></i> {{ erro }}
    </p>
  </div>

  <!-- Loading -->
  <div class="loading-area" *ngIf="importando">
    <div class="loading-spinner"></div>
    <p class="loading-texto">Buscando seu cardápio...</p>
    <p class="loading-subtexto">Isso pode levar alguns segundos</p>
  </div>

  <!-- Preview dos dados importados -->
  <div class="preview-area" *ngIf="preview && !importando">
    <div class="preview-header" *ngIf="preview.logo || preview.nome">
      <img *ngIf="preview.logo" [src]="preview.logo" class="preview-logo" alt="Logo">
      <div class="preview-header-info">
        <h3 class="preview-nome" *ngIf="preview.nome">{{ preview.nome }}</h3>
        <p class="preview-resumo">
          {{ preview.totalProdutos }} produto{{ preview.totalProdutos !== 1 ? 's' : '' }}
          em {{ preview.totalCategorias }} categoria{{ preview.totalCategorias !== 1 ? 's' : '' }}
        </p>
      </div>
    </div>

    <div class="preview-dados">
      <div class="preview-item" *ngIf="preview.endereco">
        <i class="fe-map-pin"></i>
        <span>{{ preview.endereco }}</span>
      </div>

      <div class="preview-item" *ngIf="preview.cep">
        <i class="fe-hash"></i>
        <span>CEP {{ preview.cep }}</span>
      </div>

      <div class="preview-item" *ngIf="preview.telefone">
        <i class="fe-phone"></i>
        <span>{{ preview.telefone }}</span>
      </div>

      <div class="preview-item" *ngIf="preview.latitudeLongitude">
        <i class="fe-navigation"></i>
        <span>Localização detectada</span>
      </div>

      <div class="preview-item preview-item-horarios" *ngIf="preview.horarios?.length">
        <i class="fe-clock"></i>
        <div class="preview-horarios">
          <span>Horários de funcionamento</span>
          <span class="preview-horario-dia" *ngFor="let h of formatarHorarios(preview.horarios)">{{ h }}</span>
        </div>
      </div>
    </div>

    <p class="preview-nota">
      <i class="fe-info mr-1"></i> Esses dados serão aplicados à sua loja automaticamente.
    </p>
  </div>

  <div class="step-actions" *ngIf="!importando">
    <button class="btn-anterior" (click)="voltar()">
      <i class="fe-arrow-left mr-1"></i> {{ preview ? 'Reimportar' : 'Anterior' }}
    </button>
    <button *ngIf="!preview" class="btn-proximo" [disabled]="!podeImportar" (click)="importar()">
      Importar e continuar <i class="fe-arrow-right ml-1"></i>
    </button>
    <button *ngIf="preview" class="btn-proximo" (click)="confirmarImportacao()">
      Confirmar e continuar <i class="fe-arrow-right ml-1"></i>
    </button>
  </div>
</div>
